import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Staff, StaffWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateStaff(): UseMutationResult<
  AxiosResponse<Staff>,
  AxiosError<ErrorMessage>,
  StaffWrite
> {
  const queryClient = useQueryClient();

  const createStaff = (staff: StaffWrite): Promise<AxiosResponse<Staff>> => {
    return client.post('staff/', staff);
  };

  return useMutation(createStaff, {
    onSuccess: () => {
      queryClient.invalidateQueries('staff');
      queryClient.invalidateQueries('staff-autocomplete');
    },
  });
}
